import { Font } from "@react-pdf/renderer";
import fontSrc from "@/assets/fonts/msyh.ttf";
import vnSrc from "@/assets/fonts/NotoSans-Regular.ttf";
import krSrc from "@/assets/fonts/NotoSansKR-Regular.otf";

// 全局集中注册 PDF 字体（Font store 是模块级单例，注册幂等）
Font.register({ family: "NotoSansSC", src: fontSrc });
Font.register({ family: "VnFontSrc", src: vnSrc });
Font.register({ family: "KoFontSrc", src: krSrc });

/**
 * 应用启动后空闲时预热字体：
 * 1. 静默 fetch 字体文件，写入浏览器 HTTP 缓存（生产环境 contenthash + 缓存头可命中）
 * 2. Font.load 触发下载（命中缓存）+ fontkit 解析，存入 @react-pdf 内存 font store
 * 预热失败静默忽略，不影响功能。
 */
export const prewarmPdfFonts = () => {
  const start = () => {
    Promise.all(
      [fontSrc, vnSrc, krSrc].map((src) =>
        fetch(src, { cache: "force-cache" }).catch(() => {})
      )
    )
      .then(() =>
        Promise.allSettled([
          Font.load("NotoSansSC"),
          Font.load("VnFontSrc"),
          Font.load("KoFontSrc"),
        ])
      )
      .catch(() => {});
  };

  if ("requestIdleCallback" in window) {
    requestIdleCallback(start, { timeout: 5000 });
  } else {
    setTimeout(start, 3000);
  }
};
